import { render, staticRenderFns } from "./FootSendMessage.vue?vue&type=template&id=3d80982f&"
import script from "./FootSendMessage.vue?vue&type=script&lang=js&"
export * from "./FootSendMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports